var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('layout',[_c('div',{staticClass:"container mt-4 pl-2 pr-2"},[_c('div',{staticClass:"mb-2"},[_c('ShowPath',{attrs:{"path":[
          { title: 'Início', to: '/'},
          { title: 'Boletins'},
        ]}})],1),_c('div',{staticClass:"columns mb-0"},[_c('div',{staticClass:"column"},[_c('Title1',[_vm._v(" BOLETINS ")])],1)]),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('ListAllPosts',{attrs:{"postType":"boletim"}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }